import React, { useState, useEffect } from 'react';
import Cookies from 'js-cookie';
import DatePicker from 'react-date-picker';
import { Container, Row, Col, Button } from 'react-bootstrap';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { Formik, Form, Field, ErrorMessage } from 'formik';
import { useDispatch, useSelector } from 'react-redux';
import { setFinalWinner } from 'slices/finalWinnerSlice';
import { postalCode, removeErrorCP, setErrorCP } from 'slices/postalCodeSlice';
import moment from 'moment';
import Lottie from 'lottie-react-web';
import AlertDanger from 'components/alert/AlertDanger';
import FormSidebar from 'components/formSidebar';
import * as Yup from 'yup';
import { MEMBER_URL, SUBASTAS_URL } from '../../constants/Constants';
import calendar from '../../assets/calendar.svg';
import cpLoader from '../../assets/cp-loader.json';

const FormNational = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [searchParams] = useSearchParams();

  const decodeUTF8 = (str) => {
    return decodeURIComponent(escape(window.atob(str)));
  };

  const auction = decodeUTF8(searchParams.get('title'));

  const auctionEncoded = searchParams.get('title');
  const auctionId = atob(searchParams.get('auctionId'));

  const nameURL = searchParams.get('name');
  const auctionURL = searchParams.get('title');
  const rewardTypeURL = searchParams.get('rewardType');
  const auctionIdURL = searchParams.get('auctionId');
  const rewardType = atob(searchParams.get('rewardType'));

  const validationDate = (value) => {
    const year = moment().year() - 100;
    const hoy = moment().subtract(1, 'days');

    let fechaUser;
    let yearUser;
    if (value !== undefined) {
      if (value.length >= 10) {
        const demo = value.split('/');
        fechaUser = new Date(`${demo[2]}-${demo[1]}-${demo[0]} 00:00:00`);
        yearUser = Number(value.substr(0, 4));
      }
    }

    return hoy > fechaUser && yearUser > year;
  };

  const UserSchema = Yup.object().shape({
    nameForm: Yup.string().required('* Campo requerido').matches(/^[a-zA-Zá-ú\s]+$/, 'Sin caracteres especiales'),
    lastNameForm: Yup.string().required('* Campo requerido').matches(/^[a-zA-Zá-ú\s]+$/, 'Sin caracteres especiales'),
    maternalSurnameForm: Yup.string().required('* Campo requerido').matches(/^[a-zA-Zá-ú\s]+$/, 'Sin caracteres especiales'),
    birthDateForm: Yup.string()
      .required('* Campo requerido')
      .test('DOB', 'Escribe una fecha válida', (value) => validationDate(value)),
    mailForm: Yup.string().required('* Campo requerido').email('* Email no válido'),
    phoneForm: Yup.string().required('* Campo requerido').matches(/^[0-9]{10}$/, '* Teléfono no válido'),

    postalCodeForm: Yup.string().required('* Campo requerido').matches(/^[0-9]{5}$/, '* Código postal no válido'),
    stateForm: Yup.string().required('* Campo requerido').matches(/^[a-zA-Zá-úÁ-Ú]/, 'Solo letras y espacios'),
    townForm: Yup.string().required('* Campo requerido').matches(/^[a-zA-Zá-úÁ-Ú]/, 'Solo letras y espacios'),
    cityForm: Yup.string().required('* Campo requerido').matches(/^[a-zA-Zá-úÁ-Ú]/, 'Solo letras y espacios'),

    streetForm: Yup.string().required('* Campo requerido').matches(/^[a-zA-Z0-9á-ú\s]+$/, 'Sin caracteres especiales'),
    externalNumberForm: Yup.string().required('* Campo requerido').matches(/^[a-zA-Z0-9]{1,5}$/, '* Número exterior no válido'),
    internalNumberForm: Yup.string().matches(/^[a-zA-Z0-9]{1,5}$/, '* Número interior no válido'),
    goingDateForm: Yup.string().required('* Campo requerido'),
    returnDateForm: Yup.string().required('* Campo requerido'),

    nameTwoForm: Yup.string().required('* Campo requerido').matches(/^[a-zA-Zá-ú\s]+$/, 'Sin caracteres especiales'),
    lastNameTwoForm: Yup.string().required('* Campo requerido').matches(/^[a-zA-Zá-ú\s]+$/, 'Sin caracteres especiales'),
    maternalSurnameTwoForm: Yup.string().required('* Campo requerido').matches(/^[a-zA-Zá-ú\s]+$/, 'Sin caracteres especiales'),
    birthDateTwoForm: Yup.string()
      .required('* Campo requerido')
      .test('DOB', 'Escribe una fecha válida', (value) => validationDate(value)),
    mailTwoForm: Yup.string().required('* Campo requerido').email('* Email no válido'),
    phoneTwoForm: Yup.string().required('* Campo requerido').matches(/^[0-9]{10}$/, '* Teléfono no válido'),
    suburbForm: Yup.string().required('* Campo requerido'),
    otherSuburbForm: Yup.string().when('suburbForm', {
      is: 'otra',
      then: Yup.string().required('* Campo requerido').matches(/^[a-zA-Zá-ú\s]+$/, 'Sin caracteres especiales'),
    }),
  });

  const { name, lastName, middleName, phoneNumber, email,
    address } = useSelector((state) => state.user.user);

  const [goingDate, SetGoingDate] = useState('');
  const [returnDate, SetReturnDate] = useState('');
  const [birthDateFormat] = useState('');
  const [birthDateFormatTwo] = useState('');

  const initialValues = {
    nameForm: '',
    lastNameForm: '',
    maternalSurnameForm: '',
    birthDateForm: '',
    mailForm: '',
    phoneForm: '',

    postalCodeForm: '',
    stateForm: '',
    townForm: '',
    cityForm: '',
    suburbForm: '',
    streetForm: '',
    externalNumberForm: '',
    internalNumberForm: '',
    goingDateForm: goingDate,
    returnDateForm: returnDate,

    nameTwoForm: '',
    lastNameTwoForm: '',
    maternalSurnameTwoForm: '',
    birthDateTwoForm: '',
    mailTwoForm: '',
    phoneTwoForm: '',
  };

  const savedValues = {
    nameForm: name,
    lastNameForm: lastName,
    maternalSurnameForm: middleName,
    birthDateForm: '',
    mailForm: email,
    phoneForm: phoneNumber,
    postalCodeForm: address.postalCode,
    stateForm: address.state,
    townForm: address.country,
    cityForm: address.city,
    suburbForm: address.colony,
    streetForm: address.street,
    externalNumberForm: address.extNumber,
    internalNumberForm: address.intNumber,
    goingDateForm: goingDate,
    returnDateForm: returnDate,

    nameTwoForm: '',
    lastNameTwoForm: '',
    maternalSurnameTwoForm: '',
    birthDateTwoForm: '',
    mailTwoForm: '',
    phoneTwoForm: '',
  };

  const [formValues, SetFormValues] = useState(initialValues);
  const [chekInput, SetChekInput] = useState(false);
  const [check, setCheck] = useState(false);
  const { error } = useSelector((state) => state.finalWinner.winner);
  const { statusDataWinner } = useSelector((state) => state.finalWinner);
  const { errorCP } = useSelector((state) => state.cp);
  const [selectSuburb, setSelectSuburb] = useState([]);

  const newDateFunc = (date) => {
    const newDate = new Date(date);
    let day = newDate.getDate();
    let month = newDate.getMonth() + 1;
    if (day < 10) {
      day = `0${day}`;
    }
    if (month < 10) {
      month = `0${month}`;
    }
    const year = newDate.getFullYear();
    return `${year}-${month}-${day}`;
  };

  const goingDateBlur = (setFieldValue) => {
    setFieldValue('goingDateForm', newDateFunc(goingDate));
  };

  const returnDateBlur = (setFieldValue) => {
    setFieldValue('returnDateForm', newDateFunc(returnDate));
  };

  const newDateBirthFunc = (date) => {
    const divideDate = (date.split('/'));
    const formatDate = `${divideDate[2]}-${divideDate[1]}-${divideDate[0]}`;
    return formatDate;
  };

  const birthDateBlur = (value, setFieldValue) => {
    setFieldValue('birthDateForm', newDateBirthFunc(value));
  };

  const birthDateBlurTwo = (value, setFieldValue) => {
    setFieldValue('birthDateTwoForm', newDateBirthFunc(value));
  };

  const SavedGetPostalCode = async (postalCodeAPI) => {
    const resp = await dispatch(postalCode(postalCodeAPI));
    const data = resp.payload;
    if (data === undefined) {
      dispatch(setErrorCP());
    } else if (data.length > 0) {
      const suburb = data.map((m) => m.colony);
      setSelectSuburb(suburb);
    }
  };

  const InitialGetPostalCode = async (cp, setFieldValue) => {
    const resp = await dispatch(postalCode(cp));
    const data = resp.payload;
    if (data === undefined) {
      dispatch(setErrorCP());
    } else if (data.length > 0) {
      dispatch(removeErrorCP());
      const suburb = data.map((m) => m.colony);
      setSelectSuburb(suburb);
      setFieldValue('stateForm', data[0].state);
      setFieldValue('townForm', data[0].delegation);
      setFieldValue('cityForm', data[0].town);
      setFieldValue('suburbForm', suburb[0]);
    }
  };

  const apiClic = () => {
    setCheck(!check);
    if (check) {
      SetFormValues(savedValues);
      SetChekInput(true);
    } else {
      setSelectSuburb([]);
      SetFormValues(initialValues);
      SetChekInput(false);
    }
  };

  useEffect(() => {
    apiClic();
  }, []);

  const apiSetValues = (setFieldValue) => {
    apiClic();
    SavedGetPostalCode(savedValues.postalCodeForm, setFieldValue);
  };

  useEffect(() => {
    if (error === false) {
      navigate(`/subastas-ganador-final?title=${auctionEncoded}&rewardType=${rewardTypeURL}`);
    }
  }, [error]);

  const handleLogin = () => {
    Cookies.set('redirect', `subastas-ganador/?name=${nameURL}&title=${auctionURL}&rewardType=${rewardTypeURL}&auctionId=${auctionIdURL}`);
    window.location = `${MEMBER_URL}/login?url=${SUBASTAS_URL}/#/subastas-ganador`;
  };

  const sendData = async (valores) => {
    const { nameForm, lastNameForm, maternalSurnameForm, mailForm, phoneForm,
      postalCodeForm, stateForm, townForm, cityForm, streetForm, suburbForm,
      internalNumberForm, externalNumberForm, goingDateForm, returnDateForm, otherSuburbForm,
      nameTwoForm, lastNameTwoForm, maternalSurnameTwoForm, mailTwoForm, phoneTwoForm } = valores;
    const dataFormWinner = {
      auctionId,
      info: [
        {
          passengerNumber: 1,
          name: nameForm,
          lastName: lastNameForm,
          maternalSurname: maternalSurnameForm,
          mail: mailForm,
          phone: phoneForm,
          passport: null,

          postalCode: postalCodeForm,
          state: stateForm,
          town: townForm,
          city: cityForm,
          suburb: suburbForm === 'otra' ? otherSuburbForm : suburbForm,
          street: streetForm,
          internalNumber: internalNumberForm,
          externalNumber: externalNumberForm,
          goingDate: goingDateForm,
          returnDate: returnDateForm,
          birthDate: birthDateFormat,
        },
        {
          passengerNumber: 2,
          name: nameTwoForm,
          lastName: lastNameTwoForm,
          maternalSurname: maternalSurnameTwoForm,
          mail: mailTwoForm,
          phone: phoneTwoForm,
          passport: null,
          birthDate: birthDateFormatTwo,
        },
      ],
    };

    const resp = await dispatch(setFinalWinner(dataFormWinner));

    if (resp.payload.status === 403) {
      handleLogin();
    }
  };

  const handleFormatDay = (event) => {
    const input = event.target;

    if (event.charCode < 47 || event.charCode > 57) {
      event.preventDefault();
    }
    const len = input.value.length;

    if (len !== 1 || len !== 3) {
      if (event.charCode === 47) {
        event.preventDefault();
      }
    }

    if (len === 2) {
      input.value += '/';
    }

    if (len === 5) {
      input.value += '/';
    }
  };

  const [birthDateInput, setBirthDateInput] = useState('');
  const [birthDateInputTwo, setBirthDateInputTwo] = useState('');

  const handleChangedBirthday = (event) => {
    handleFormatDay(event);
    const dateLenght = event.target.value.length;
    if (dateLenght <= 10) {
      setBirthDateInput(event.target.value);
    }
  };

  const handleChangedBirthdayTwo = (event) => {
    handleFormatDay(event);
    const dateLenght = event.target.value.length;
    if (dateLenght <= 10) {
      setBirthDateInputTwo(event.target.value);
    }
  };

  const actualDays = new Date(new Date());

  const { message } = useSelector((state) => state.finalWinner.winner);

  return (
    <div className="bg-white">
      <Container className="py-60">
        <Row className="ml-md-5">
          <Col md={8} className="ml-md-3 order-2 order-md-1">
            <h2 className="mb-4">
              {`¡Felicidades ${name} eres el ganador de la Subasta!`}
            </h2>

            {error && (
              <AlertDanger
                heading="¡Lo sentimos!"
                body={message}
                type="General" />
            )}

            <Formik
              initialValues={formValues}
              validationSchema={UserSchema}
              enableReinitialize
              validateOnMount
              onSubmit={async (valores) => {
                sendData(valores);
              }}>
              {({ values, setFieldValue }) => {
                return (
                  <Form>
                    <div className="p-3 bdr-2 border">
                      <Row>
                        <Col xs={12}>
                          <p className="lh-24 text-tangaroa">Ingresa los datos solicitados. Una vez completados, haz clic en el botón ‘Enviar’ y pronto nos contactaremos contigo para hacer entrega de tu premio.</p>
                        </Col>

                        <Col md={12}>
                          <button
                            type="button"
                            className="custom-checkbox my-3 btn-link"
                            onClick={() => apiSetValues(setFieldValue)}>
                            <Field
                              type="checkbox"
                              checked={chekInput}
                              className="custom-control-input"
                              name="api"
                              placeholder="Ingresa tu Número de Cuenta" />
                            <label htmlFor="check" className="custom-control-label text-tangaroa">Utilizar datos registrados en Aeroméxico Rewards</label>
                          </button>
                        </Col>

                        <Col xs={12}>
                          <h3 className="text-dark-blue">
                            <i className="fas fa-user mr-2" />
                            Pasajero 1
                          </h3>
                        </Col>

                        <Col xs={12}>
                          <h3 className="text-tangaroa">Datos personales</h3>
                        </Col>

                        <Col md={6}>
                          <div className="custom-control">
                            <label htmlFor="nameForm">Nombre(s) *</label>
                            <Field
                              className="form-control"
                              type="text"
                              name="nameForm" />
                          </div>
                          <div className="mb-1">
                            <small className="text-error">
                              <ErrorMessage name="nameForm" />
                            </small>
                          </div>
                        </Col>

                        <Col md={6}>
                          <div className="custom-control">
                            <label htmlFor="lastNameForm">Apellido Paterno *</label>
                            <Field
                              className="form-control"
                              type="text"
                              name="lastNameForm" />
                          </div>
                          <div className="mb-1">
                            <small className="text-error">
                              <ErrorMessage name="lastNameForm" />
                            </small>
                          </div>
                        </Col>

                        <Col md={6}>
                          <div className="custom-control">
                            <label htmlFor="maternalSurnameForm">Apellido Materno *</label>
                            <Field
                              className="form-control"
                              type="text"
                              name="maternalSurnameForm" />
                          </div>
                          <div className="mb-1">
                            <small className="text-error">
                              <ErrorMessage name="maternalSurnameForm" />
                            </small>
                          </div>
                        </Col>

                        <Col md={6}>
                          <div className="custom-control">
                            <label htmlFor="birthDateForm">Fecha de nacimiento *</label>
                            <Field
                              className="form-control d-none"
                              type="string"
                              name="birthDateForm" />
                            <input
                              value={birthDateInput}
                              onChange={handleChangedBirthday}
                              onBlur={() => birthDateBlur(birthDateInput, setFieldValue)}
                              className="form-control"
                              type="string"
                              placeholder="dd/mm/yyyy" />
                          </div>
                          <div className="mb-1">
                            <small className="text-error">
                              <ErrorMessage name="birthDateForm" />
                            </small>
                          </div>
                        </Col>

                        <Col md={6}>
                          <div className="custom-control">
                            <label htmlFor="mailForm">Correo electrónico *</label>
                            <Field
                              className="form-control"
                              type="mail"
                              autoComplete="off"
                              name="mailForm" />
                          </div>
                          <div className="mb-1">
                            <small className="text-error">
                              <ErrorMessage name="mailForm" />
                            </small>
                          </div>
                        </Col>

                        <Col md={6}>
                          <div className="custom-control">
                            <label htmlFor="phoneForm">Teléfono *</label>
                            <Field
                              className="form-control"
                              type="tel"
                              name="phoneForm" />
                          </div>
                          <div className="mb-1">
                            <small className="text-error">
                              <ErrorMessage name="phoneForm" />
                            </small>
                          </div>
                        </Col>
                      </Row>

                      <Row>

                        <Col xs={12} className="mt-30">
                          <h3 className="text-tangaroa">Dirección</h3>
                          {errorCP && (
                            <AlertDanger
                              heading="¡Lo sentimos!"
                              body="El código postal ingresado no se encuentra dentro
                              de nuestra cobertura. Por favor intenta con otro."
                              type="postalCode" />
                          )}
                        </Col>

                        <Col md={6}>
                          <div className="custom-control">
                            <label htmlFor="postalCodeForm">Código Postal *</label>
                            <Field
                              className="form-control"
                              autoComplete="nope"
                              type="text"
                              onBlur={() => InitialGetPostalCode(values.postalCodeForm,
                                setFieldValue)}
                              name="postalCodeForm" />
                          </div>
                          <div className="mb-1">
                            <small className="text-error">
                              <ErrorMessage name="postalCodeForm" />
                            </small>
                          </div>
                        </Col>
                        <Col md={6}>
                          <div className="custom-control">
                            <label htmlFor="stateForm">Estado *</label>
                            <Field
                              className="form-control"
                              type="text"
                              name="stateForm" />
                          </div>
                          <div className="mb-1">
                            <small className="text-error">
                              <ErrorMessage name="stateForm" />
                            </small>
                          </div>
                        </Col>

                        <Col md={6}>
                          <div className="custom-control">
                            <label htmlFor="cityForm">Ciudad *</label>
                            <Field
                              className="form-control"
                              type="text"
                              name="cityForm" />
                          </div>
                          <div className="mb-1">
                            <small className="text-error">
                              <ErrorMessage name="cityForm" />
                            </small>
                          </div>
                        </Col>

                        <Col md={6}>
                          <div className="custom-control">
                            <label htmlFor="townForm">Municipio o Delegación *</label>
                            <Field
                              className="form-control"
                              type="text"
                              name="townForm" />
                          </div>
                          <div className="mb-1">
                            <small className="text-error">
                              <ErrorMessage name="townForm" />
                            </small>
                          </div>
                        </Col>

                        <Col md={6}>
                          <div className="custom-select-cp">
                            <label htmlFor="suburbForm">Colonia *</label>
                            <Field
                              as="select"
                              name="suburbForm"
                              className="custom-select">
                              {values.suburbForm === '' && (<option value="">Selecciona una Colonia</option>)}

                              {selectSuburb.length > 0 && (
                                selectSuburb.map((s) => (
                                  <option key={s} value={s}>{s}</option>
                                ))
                              )}
                              <option value="otra">Otra</option>
                            </Field>
                          </div>
                          <div className="mb-1">
                            <small className="text-error">
                              <ErrorMessage name="suburbForm" />
                            </small>
                          </div>
                        </Col>
                        {values.suburbForm === 'Otra' && (
                          <Col md={6}>
                            <div className="custom-control">
                              <label htmlFor="otherSuburbForm">Ingresa la Colonia *</label>
                              <Field
                                className="form-control"
                                type="text"
                                required
                                name="otherSuburbForm" />
                            </div>
                            <div className="mb-1">
                              <small className="text-error">
                                <ErrorMessage name="otherSuburbForm" />
                              </small>
                            </div>
                          </Col>
                        )}

                        <Col md={6}>
                          <div className="custom-control">
                            <label htmlFor="streetForm">Calle *</label>
                            <Field
                              className="form-control"
                              type="text"
                              name="streetForm" />
                          </div>
                          <div className="mb-1">
                            <small className="text-error">
                              <ErrorMessage name="streetForm" />
                            </small>
                          </div>
                        </Col>

                        <Col md={6}>
                          <div className="custom-control">
                            <label htmlFor="externalNumberForm">No. Exterior *</label>
                            <Field
                              className="form-control"
                              type="text"
                              name="externalNumberForm" />
                          </div>
                          <div className="mb-1">
                            <small className="text-error">
                              <ErrorMessage name="externalNumberForm" />
                            </small>
                          </div>
                        </Col>

                        <Col md={6}>
                          <div className="custom-control">
                            <label htmlFor="internalNumberForm">No. Interior</label>
                            <Field
                              className="form-control"
                              type="text"
                              name="internalNumberForm" />
                          </div>
                          <div className="mb-1">
                            <small className="text-error">
                              <ErrorMessage name="internalNumberForm" />
                            </small>
                          </div>
                        </Col>

                        <Col xs={12}>
                          <h3 className="text-tangaroa mt-30 mb-15">Fechas en las que te gustaría viajar</h3>
                        </Col>

                        <Col md={6}>
                          <div className="custom-control">
                            <label htmlFor="select-start">Fecha de ida *</label>
                            <Field
                              className="form-control d-none"
                              type="text"
                              name="goingDateForm" />
                            <DatePicker
                              clearIcon={null}
                              calendarIcon={<img src={calendar} className="img-fluid" alt="Gift" />}
                              locale="es-mx"
                              required
                              selected={goingDate}
                              value={goingDate}
                              onChange={(date) => SetGoingDate(date)}
                              onBlur={() => goingDateBlur(setFieldValue)}
                              minDate={actualDays}
                              name="goingDateForm"
                              dateFormat="DD/MM/YYYY" />
                          </div>

                          <div className="mb-1">
                            <small className="text-error">
                              <ErrorMessage name="goingDateForm" />
                            </small>
                          </div>
                        </Col>

                        <Col md={6}>
                          <div className="custom-control">
                            <label htmlFor="select-start">Fecha de regreso *</label>
                            <Field
                              className="form-control d-none"
                              type="text"
                              name="returnDateForm" />
                            <DatePicker
                              clearIcon={null}
                              calendarIcon={<img src={calendar} className="img-fluid" alt="Gift" />}
                              locale="es-mx"
                              required
                              selected={returnDate}
                              value={returnDate}
                              onChange={(date) => SetReturnDate(date)}
                              onBlur={() => returnDateBlur(setFieldValue)}
                              minDate={goingDate}
                              name="returnDateForm"
                              dateFormat="DD/MM/YYYY" />
                          </div>

                          <div className="mb-1">
                            <small className="text-error">
                              <ErrorMessage name="returnDateForm" />
                            </small>
                          </div>
                        </Col>

                        <Col xs={12}>
                          <h3 className="text-dark-blue mt-30">
                            <i className="fas fa-user mr-2" />
                            Pasajero 2
                          </h3>
                        </Col>

                        <Col xs={12}>
                          <h3 className="text-secondary">Datos personales</h3>
                        </Col>

                        <Col md={6}>
                          <div className="custom-control">
                            <label htmlFor="nameTwoForm">Nombre(s) *</label>
                            <Field
                              className="form-control"
                              type="text"
                              value={values.nameTwoForm}
                              name="nameTwoForm" />
                          </div>
                          <div className="mb-1">
                            <small className="text-error">
                              <ErrorMessage name="nameTwoForm" />
                            </small>
                          </div>
                        </Col>

                        <Col md={6}>
                          <div className="custom-control">
                            <label htmlFor="lastNameTwoForm">Apellido Paterno *</label>
                            <Field
                              className="form-control"
                              type="text"
                              value={values.lastNameTwoForm}
                              name="lastNameTwoForm" />
                          </div>
                          <div className="mb-1">
                            <small className="text-error">
                              <ErrorMessage name="lastNameTwoForm" />
                            </small>
                          </div>
                        </Col>

                        <Col md={6}>
                          <div className="custom-control">
                            <label htmlFor="maternalSurnameTwoForm">Apellido Materno *</label>
                            <Field
                              className="form-control"
                              type="text"
                              name="maternalSurnameTwoForm" />
                          </div>
                          <div className="mb-1">
                            <small className="text-error">
                              <ErrorMessage name="maternalSurnameTwoForm" />
                            </small>
                          </div>
                        </Col>

                        <Col md={6}>
                          <div className="custom-control">
                            <label htmlFor="birthDateTwoForm">Fecha de nacimiento *</label>
                            <Field
                              className="form-control d-none"
                              type="string"
                              name="birthDateTwoForm" />
                            <input
                              value={birthDateInputTwo}
                              onChange={handleChangedBirthdayTwo}
                              onBlur={() => birthDateBlurTwo(birthDateInputTwo, setFieldValue)}
                              className="form-control"
                              type="string"
                              placeholder="dd/mm/yyyy" />
                          </div>
                          <div className="mb-1">
                            <small className="text-error">
                              <ErrorMessage name="birthDateTwoForm" />
                            </small>
                          </div>
                        </Col>

                        <Col md={6}>
                          <div className="custom-control">
                            <label htmlFor="mailTwoForm">Correo electrónico *</label>
                            <Field
                              className="form-control"
                              type="mail"
                              autoComplete="off"
                              name="mailTwoForm" />
                          </div>
                          <div className="mb-1">
                            <small className="text-error">
                              <ErrorMessage name="mailTwoForm" />
                            </small>
                          </div>
                        </Col>

                        <Col md={6}>
                          <div className="custom-control">
                            <label htmlFor="phoneTwoForm">Teléfono *</label>
                            <Field
                              className="form-control"
                              type="tel"
                              name="phoneTwoForm" />
                          </div>
                          <div className="mb-1">
                            <small className="text-error">
                              <ErrorMessage name="phoneTwoForm" />
                            </small>
                          </div>
                        </Col>

                      </Row>
                    </div>

                    {statusDataWinner === 'loading' ? (
                      <div className="d-flex justify-content-end mt-3">
                        <Lottie
                          width={60}
                          options={{
                            animationData: cpLoader,
                          }} />
                      </div>
                    ) : (
                      <div className="d-flex justify-content-end mt-3">
                        <Button variant="primary" type="submit">Enviar</Button>
                      </div>
                    )}

                  </Form>
                );
              }}
            </Formik>
          </Col>
          <Col md={3} className="order-1 order-md-2 mb-1 mb-md-0">
            <FormSidebar auction={auction} type={rewardType} />
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default FormNational;
